<template>
  <span>
    <img :style="{'margin-right': margin_right, 'height': height, 'animation': 'rotation 2s infinite linear'}" :src="icons.spinnerBlack" />
  </span>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    extends: BaseComponent,
    props: {
        margin_right: { required: false, default: '0px', type: String},
        height: { required: false, default: '20px', type: String},
    }
})

</script>
